import { render } from "./UserScoresChart.vue?vue&type=template&id=393b3c12&scoped=true"
import script from "./UserScoresChart.vue?vue&type=script&lang=js"
export * from "./UserScoresChart.vue?vue&type=script&lang=js"

import "./UserScoresChart.vue?vue&type=style&index=0&id=393b3c12&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-393b3c12"]])

export default __exports__